import { useGoogleLogin } from "@react-oauth/google"
import { useNavigate } from "react-router-dom"
import { useState } from "react"
import axios from "axios"
import "../styles/auth.css"

const API = process.env.REACT_APP_API_URL || "http://localhost:8000"

export default function Login() {
    const nav = useNavigate()
    const [error, setError] = useState("")
    const [trialExpired, setTrialExpired] = useState(false)
    const [loading, setLoading] = useState(false)

    const googleLogin = useGoogleLogin({
        onSuccess: async (tokenResponse) => {
            setLoading(true); setError(""); setTrialExpired(false)
            try {
                const res = await axios.post(`${API}/oauth/google`, {
                    token: tokenResponse.access_token,
                })
                if (res.data.error === "subscription_required") {
                    setTrialExpired(true)
                    return
                }
                if (res.data.token) {
                    localStorage.setItem("token", res.data.token)
                    nav("/dashboard")
                } else {
                    setError("Google login failed. Please try email login.")
                }
            } catch {
                setError("Google login failed. Please try email login below.")
            } finally {
                setLoading(false)
            }
        },
        onError: () => setError("Google login was cancelled or failed."),
    })

    const handleEmailLogin = async (e) => {
        e.preventDefault()
        setError(""); setTrialExpired(false); setLoading(true)

        const email = e.target.email.value.trim().toLowerCase()
        const password = e.target.password.value

        try {
            const res = await axios.post(`${API}/login`, { email, password })
            if (res.data.error === "subscription_required") {
                setTrialExpired(true)
                return
            }
            if (res.data.error) {
                setError("Invalid email or password.")
                return
            }
            localStorage.setItem("token", res.data.token)
            nav("/dashboard")
        } catch (err) {
            if (err.response?.status === 429) {
                setError("Too many attempts. Please wait a few minutes.")
            } else {
                setError("Invalid email or password.")
            }
        } finally {
            setLoading(false)
        }
    }

    return (
        <div className="auth-page">
            <div className="auth-card">
                <div className="auth-logo">ArbSignal</div>
                <h2 className="auth-title">Welcome back</h2>
                <p className="auth-sub">Sign in to your account</p>

                <div className="auth-buttons">
                    <button
                        className="oauth-btn google-btn"
                        onClick={() => googleLogin()}
                        disabled={loading}
                    >
                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
                            <path d="M17.64 9.2c0-.637-.057-1.251-.164-1.84H9v3.481h4.844c-.209 1.125-.843 2.078-1.796 2.717v2.258h2.908c1.702-1.567 2.684-3.875 2.684-6.615z" fill="#4285F4"/>
                            <path d="M9 18c2.43 0 4.467-.806 5.956-2.18l-2.908-2.259c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H.957v2.332A8.997 8.997 0 009 18z" fill="#34A853"/>
                            <path d="M3.964 10.71A5.41 5.41 0 013.682 9c0-.593.102-1.17.282-1.71V4.958H.957A8.996 8.996 0 000 9c0 1.452.348 2.827.957 4.042l3.007-2.332z" fill="#FBBC05"/>
                            <path d="M9 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.463.891 11.426 0 9 0A8.997 8.997 0 00.957 4.958L3.964 7.29C4.672 5.163 6.656 3.58 9 3.58z" fill="#EA4335"/>
                        </svg>
                        Continue with Google
                    </button>

                </div>

                <div className="auth-divider"><span>or</span></div>

                <form className="auth-form" onSubmit={handleEmailLogin}>
                    <input className="auth-input" type="email" name="email"
                           placeholder="Email address" required autoComplete="email" />
                    <input className="auth-input" type="password" name="password"
                           placeholder="Password" required autoComplete="current-password" />
                    {error && (
                        <p style={{ color: "#f87171", fontSize: 13, margin: 0 }}>{error}</p>
                    )}
                    {trialExpired && (
                        <div style={{
                            background: "rgba(167,139,250,0.1)",
                            border: "1px solid rgba(167,139,250,0.3)",
                            padding: "12px 14px", borderRadius: 10, fontSize: 13,
                            color: "#a78bfa",
                        }}>
                            <p style={{ margin: 0, marginBottom: 10 }}>
                                Your free trial has ended. Email{" "}
                                <a href="mailto:support@arb-signal.com" style={{ color: "#a78bfa", textDecoration: "underline" }}>
                                    support@arb-signal.com
                                </a>{" "}
                                to reactivate, or register a new account.
                            </p>
                            <span
                                className="auth-link"
                                onClick={() => nav("/register")}
                                style={{ fontWeight: 600 }}
                            >
                                Register new account →
                            </span>
                        </div>
                    )}
                    <button type="submit" className="auth-submit" disabled={loading}>
                        {loading ? "Signing in…" : "Sign in"}
                    </button>
                </form>

                <p className="auth-footer" style={{ marginTop: 16 }}>
                    <span className="auth-link" onClick={() => nav("/forgot-password")}>
                        Forgot your password?
                    </span>
                </p>

                <p className="auth-footer" style={{ marginTop: 8 }}>
                    Don't have an account?{" "}
                    <span className="auth-link" onClick={() => nav("/register")}>
                        Start free trial
                    </span>
                </p>
            </div>
        </div>
    )
}
